import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class ProductTypeApi {
  context: AuthContextProps;

  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get(id: number, lineId: number | null, medium?: number) {
    const uri =
      id === 10
        ? (lineId !== null && lineId !== undefined
            ? "a/internet/NgnLineSpecs"
            : "n/internet/NgnLineSpecs")
        : (lineId !== null && lineId !== undefined
            ? "a/internet/productType"
            : "n/internet/productType");

    let params = "";

    if (lineId !== null && lineId !== undefined)
      params += `?lineId=${lineId}`;

    if (medium !== undefined)
      params += params ? `&medium=${medium}` : `?medium=${medium}`;

    return getData({
      uri,
      id,
      params,
      context: this.context,
    });
  }
}
